<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.rapor_grubu"  url="BrandReports" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">


<div class="mt-4">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>

<div   v-for="language in languages" :key="item.id">
<ClickEditInputText  v-for="translation in item.translations" :key="translation.id" :title="language.name+ ' '+$store.state.languages.lang_phrases.isim" :value="translation.translation" :valkey="translation.id" @dataChanged="translationChanged" v-show="translation.language_id == language.id"></ClickEditInputText>  
</div>
<!--name and translations -->

<hr>



</div>

</template>


</div>
</template>

<script>
export default {

  name: 'BrandReportVisualGroup',

  data () {
    return {
      loading:true, 
      drag:false,
      item:null,  
      languages:[],
    }
  },
  computed:{
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.renewData()
      }
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    start(event)
    {
      this.drag = true
    },
    end(event)
    { 
      this.drag = false
    },
    change(event)
    {   
      let formdata = new FormData()
      formdata.append("categories",JSON.stringify(this.item.rootcategories))
      this.generalSubmission(formdata,"custom_attribute/reorder_categories",this.renewData)
    },
    async renewData()
    {
      this.item = await this.generalApiGetWithoutLoader("brand_report_group/"+this.$route.params.group_id)
      
      this.languages = await this.generalApiGetWithoutLoader("languages")
      
      await console.log(this.item)
    },
    async getData()
    {
      this.loading = await true
      
      await this.renewData()

      this.loading = await false
    },
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"brand_report_group/"+this.$route.params.group_id,this.renewData)
    },
    translationChanged(data)
    {
        console.log(data.value)
        console.log(data.key)
        let formdata = new FormData()
        formdata.append("data",data.value)
        this.generalSubmission(formdata,"brand_report_group_translation/"+data.key,this.renewData)
    },

  },
}
</script>

<style lang="css" scoped>
</style>